export default "__VITE_ASSET__45b6f000__"